/**
   This mixin has a dependency from the class.
   The class is required to have a computed and data
   property called `selectDocumentModel` and `documentModalForKey`.
   It must return the object in which we are goind to
   operate on.
*/

const documentsModalTitle = {
  contrato_social: "CONTRATO SOCIAL",
  estatuto: "ESTATUTO",
  ata: "ATA",
  outros: "OUTROS"
};

export default {
  data() {
    return {
      documentModalForKey: null
    };
  },
  computed: {
    documentModalTitle() {
      return `ANEXAR ${documentsModalTitle[this.documentModalForKey]}`;
    },
    isDocumentModalOpen() {
      return this.documentModalForKey !== null;
    }
  },
  methods: {
    onToggleDocumentModal() {
      this.documentModalForKey = null;
    },
    onSelectedDocument(document) {
      for (var i = document.length - 1; i >= 0; i--) {
        this.selectDocumentModel[this.documentModalForKey].unshift(document[i]);
      }
    },
    onToggleSingleDocumentModal(key) {
      this.documentModalForKey = key;
    },
    onPreviewDocument(/* { name } */) {
      // TODO(dias): implement.
    },
    onRemoveDocument({ name }) {
      this.$set(this.selectDocumentModel, name, null);
    }
  }
};
